  <template>
  <div
    v-bind:class="[sectionClass]"
    v-bind:style="{ height: sectionHeight }"
    ref="block">
    <div
      v-bind:class="[
        parallax ? parallaxClass : '',
        fixed ? fixedClass : '',
        containerClass
      ]"
      ref="parallax">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    parallax: {
      default: true,
      type: Boolean
    },
    speedFactor: {
      default: 0.15,
      type: Number
    },
    fixed: {
      default: false,
      type: Boolean
    },
    breakpoint: {
      default: '(min-width: 968px)',
      type: String
    },
    sectionHeight: {
      default: '50vh',
      type: String,
      required: false
    },
    sectionClass: {
      type: String,
      default: 'parallax-section'
    },
    containerClass: {
      type: String,
      default: 'parallax-container'
    },
    parallaxClass: {
      type: String,
      default: 'is-parallax'
    },
    fixedClass: {
      type: String,
      default: 'is-fixed'
    },
    direction: {
      type: String,
      default: 'up'
    }
  },

  data () {
    return {
      el: null,
      mediaQuery: null
    }
  },

  mounted () {
    if (this.parallax && !this.fixed) {
      this.el = this.$refs.parallax
      window.requestAnimationFrame = window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (f) {
        setTimeout(f, 1000 / 60)
      }
      this.init()
    }
  },

  methods: {
    animateElement () {
      const parentHeight = this.$refs.block.offsetHeight
      const parallaxHeight = this.$refs.parallax.offsetHeight
      const availableOffset = parallaxHeight - parentHeight
      let animationValue = (window.pageYOffset * this.speedFactor)

      if (animationValue <= availableOffset && animationValue >= 0) {
        this.el.style.transform = `translate3d(0, ${animationValue * this.directionValue}px ,0)`
      }
    },

    scrollHandler () {
      window.requestAnimationFrame(() => {
        if (this.isInView(this.$refs.parallax)) {
          this.animateElement()
        }
      })
    },

    isInView (el) {
      let rect = el.getBoundingClientRect()

      return (
        rect.bottom >= 0 &&
        rect.top <= (window.innerHeight || document.documentElement.clientHeight)
      )
    },

    setupListener () {
      if (this.mediaQuery.matches) {
        window.addEventListener('scroll', this.scrollHandler, false)
      } else {
        window.removeEventListener('scroll', this.scrollHandler, false)
      }
    },

    init () {
      this.mediaQuery = window.matchMedia(this.breakpoint)

      if (this.mediaQuery) {
        this.mediaQuery.addListener(this.setupListener)
        this.setupListener()
      }
    }
  },

  beforeDestroy () {
    window.removeEventListener('scroll', this.scrollHandler, false)
  },

  computed: {
    directionValue () {
      return this.direction === 'down' ? +1 : -1
    }
  }
}
</script>

<style lang="scss">
@import '../assets/scss/beach-built/imports';

.parallax-section {
  position: relative;
  min-height: rem(350);
  scroll-behavior: smooth;
  overflow: hidden;
  z-index: -1;

  .parallax-container {
    width: 100%;
    height: 120%;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      max-width: none;
      @include object-fit(cover, top);
    }

    &.is-parallax {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      will-change: transform;

      img {
        width: 100%;
        height: 100%;
        max-width: none;
        @include object-fit(cover, top);
      }
    }

    &.is-fixed {
      position: fixed;
      will-change: transform;

      img {
        height: 100vh;
        max-width: none;
      }
    }
  }

  @include media-breakpoint-up(lg) {
    min-height: 70vh;
  }
}
</style>
